import { ArrowRight } from "lucide-react";

// HP4 draft — full-bleed "Our unique ingredient" (hinokitiol / Beta-T) hero.
const GREEN = "https://images.unsplash.com/photo-1593900154763-1db4833d1784?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const UniqueIngredientV4 = () => (
  <section className="bg-white py-8 lg:py-12" data-testid="hp4-unique-ingredient">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10">
      <div className="relative overflow-hidden rounded-sm min-h-[420px] lg:min-h-[520px] flex items-center">
        <img src={GREEN} alt="Hinokitiol — our unique ingredient" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/25 to-transparent" />
        <div className="relative z-10 px-8 lg:px-16 max-w-[36rem]">
          <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-white/70 mb-4">Our unique ingredient</div>
          <h2 className="text-[32px] sm:text-[40px] lg:text-[52px] leading-[1.04] tracking-[-0.02em] text-white">
            The science of <span className="italic">hinokitiol.</span>
          </h2>
          <p className="mt-5 text-[15px] lg:text-[16px] leading-relaxed text-white/85 max-w-[28rem]">
            Riversol's signature antioxidant — Beta-T, found in the Pacific red cedar — visibly brightens dark spots, improves clarity and evens skin texture, all while remaining gentle on sensitive skin.
          </p>
          <a
            href="https://www.riversol.com/blogs/riversol/the-natural-benefits-of-beta-thujaplicin"
            data-testid="hp4-ingredient-cta"
            className="group mt-8 inline-flex items-center gap-2 border border-white/70 text-white rounded-full px-7 py-3.5 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-white hover:text-neutral-900 transition-colors"
          >
            About hinokitiol
            <ArrowRight size={15} strokeWidth={1.8} className="transition-transform group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default UniqueIngredientV4;
